module.exports = __webpack_public_path__ + "static/media/spinner.02bf8a9a.svg";